/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ added: NonNullable<unknown>, failed: NonNullable<unknown> }} Team_Manager_Import_SummaryInputs */



/**
* | output |
* | --- |
* | "{added} added, {failed} failed" |
*
* @param {Team_Manager_Import_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_summary = /** @type {((inputs: Team_Manager_Import_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.added} ajouté(s), ${i?.failed} en échec`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.added} hinzugefügt, ${i?.failed} fehlgeschlagen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.added} aggiunti, ${i?.failed} non riusciti`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавлено: ${i?.added}, ошибок: ${i?.failed}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.added} añadidos, ${i?.failed} con error`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已添加 ${i?.added} 位，失败 ${i?.failed} 位`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.added} 人追加、${i?.failed} 件失敗`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.added} जोड़े गए, ${i?.failed} विफल`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.added} adicionados, ${i?.failed} falharam`)
	return /** @type {LocalizedString} */ (`${i?.added} added, ${i?.failed} failed`)
});